"use strict";

var _regeneratorRuntime = require("/home/guest/workspace/tutorials/tutorial-netlify-c8-example/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/guest/workspace/tutorials/tutorial-netlify-c8-example/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/guest/workspace/tutorials/tutorial-netlify-c8-example/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var helper_1 = require("./util/helper");

var btoa_1 = require("./util/btoa");

var query_string_1 = require("query-string"); // 2 document
// 3 edge
// 4 persistent


var webSocket_1 = require("./util/webSocket");

var StreamConstants;

(function (StreamConstants) {
  StreamConstants["PERSISTENT"] = "persistent";
})(StreamConstants = exports.StreamConstants || (exports.StreamConstants = {}));

var Stream =
/*#__PURE__*/
function () {
  function Stream(connection, name) {
    var local = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isCollectionStream = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, Stream);

    this._connection = connection;
    this.isCollectionStream = isCollectionStream;
    this.local = local;
    this._consumers = [];
    this._setIntervalId = undefined;
    this._producerIntervalId = undefined;
    this.name = name;
    var topic = this.name;

    if (!this.isCollectionStream) {
      if (this.local) topic = "c8locals.".concat(this.name);else topic = "c8globals.".concat(this.name);
    }

    this.topic = topic;
  }

  _createClass(Stream, [{
    key: "_getPath",
    value: function _getPath(useName, urlSuffix) {
      var topic = useName ? this.name : this.topic;
      return helper_1.getFullStreamPath(topic, urlSuffix);
    }
  }, {
    key: "createStream",
    value: function createStream() {
      return this._connection.request({
        method: "POST",
        path: this._getPath(true),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "expireMessagesOnAllSubscriptions",
    value: function expireMessagesOnAllSubscriptions(expireTimeInSeconds) {
      var urlSuffix = "/all_subscription/expireMessages/".concat(expireTimeInSeconds);
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "backlog",
    value: function backlog() {
      var urlSuffix = "/backlog";
      return this._connection.request({
        method: "GET",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getStreamStatistics",
    value: function getStreamStatistics() {
      var urlSuffix = "/stats";
      return this._connection.request({
        method: "GET",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "deleteSubscription",
    value: function deleteSubscription(subscription) {
      var urlSuffix = "/subscription/".concat(subscription);
      return this._connection.request({
        method: "DELETE",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "resetSubscriptionToPosition",
    value: function resetSubscriptionToPosition(subscription) {
      var urlSuffix = "/subscription/".concat(subscription);
      return this._connection.request({
        method: "PUT",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "expireMessages",
    value: function expireMessages(subscription, expireTimeInSeconds) {
      var urlSuffix = "/subscription/".concat(subscription, "/expireMessages/").concat(expireTimeInSeconds);
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "resetCursor",
    value: function resetCursor(subscription) {
      var urlSuffix = "/subscription/".concat(subscription, "/resetcursor");
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "resetSubscriptionToTimestamp",
    value: function resetSubscriptionToTimestamp(subscription, timestamp) {
      var urlSuffix = "/subscription/".concat(subscription, "/resetcursor/").concat(timestamp);
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "skipNumberOfMessages",
    value: function skipNumberOfMessages(subscription, numMessages) {
      var urlSuffix = "/subscription/".concat(subscription, "/skip/").concat(numMessages);
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "skipAllMessages",
    value: function skipAllMessages(subscription) {
      var urlSuffix = "/subscription/".concat(subscription, "/skip_all");
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "getSubscriptionList",
    value: function getSubscriptionList() {
      var urlSuffix = "/subscriptions";
      return this._connection.request({
        method: "GET",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "terminateStream",
    value: function terminateStream() {
      var urlSuffix = "/terminate";
      return this._connection.request({
        method: "POST",
        path: this._getPath(false, urlSuffix),
        qs: "local=".concat(this.local)
      }, function (res) {
        return res.body;
      });
    }
  }, {
    key: "consumer",
    value: function consumer(subscriptionName, callbackObj, dcName) {
      var _this = this;

      var params = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var lowerCaseUrl = dcName.toLocaleLowerCase();
      if (lowerCaseUrl.includes("http") || lowerCaseUrl.includes("https")) throw "Invalid DC name";
      var onopen = callbackObj.onopen,
          onclose = callbackObj.onclose,
          onerror = callbackObj.onerror,
          onmessage = callbackObj.onmessage;
      var persist = StreamConstants.PERSISTENT;
      var region = this.local ? "c8local" : "c8global";

      var tenant = this._connection.getTenantName();

      var dbName = this._connection.getFabricName();

      var queryParams = query_string_1.stringify(params);
      if (!dbName || !tenant) throw "Set correct DB and/or tenant name before using.";
      var consumerUrl = "wss://".concat(dcName, "/_ws/ws/v2/consumer/").concat(persist, "/").concat(tenant, "/").concat(region, ".").concat(dbName, "/").concat(this.topic, "/").concat(subscriptionName, "?").concat(queryParams);

      this._consumers.push(webSocket_1.ws(consumerUrl));

      var lastIndex = this._consumers.length - 1;
      var consumer = this._consumers[lastIndex];
      consumer.on("open", function () {
        typeof onopen === "function" && onopen();
      });
      consumer.on("close", function () {
        _this._setIntervalId && clearInterval(_this._setIntervalId);
        typeof onclose === "function" && onclose();
      });
      consumer.on("error", function (e) {
        typeof onerror === "function" && onerror(e);
      });
      consumer.on("message", function (msg) {
        return __awaiter(_this, void 0, void 0,
        /*#__PURE__*/
        _regeneratorRuntime.mark(function _callee() {
          var message, ackMsg, payload, shouldAck;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  message = JSON.parse(msg);
                  ackMsg = {
                    messageId: message.messageId
                  };
                  payload = message.payload;

                  if (!(payload !== btoa_1.btoa("noop") && payload !== "noop")) {
                    _context.next = 11;
                    break;
                  }

                  if (!(typeof onmessage === "function")) {
                    _context.next = 9;
                    break;
                  }

                  _context.next = 7;
                  return onmessage(msg);

                case 7:
                  shouldAck = _context.sent;

                  if (shouldAck !== false) {
                    consumer.send(JSON.stringify(ackMsg));
                  }

                case 9:
                  _context.next = 12;
                  break;

                case 11:
                  consumer.send(JSON.stringify(ackMsg));

                case 12:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
      });
      !this._noopProducer && this.noopProducer(dcName);
      return consumer;
    }
  }, {
    key: "noopProducer",
    value: function noopProducer(dcName) {
      var _this2 = this;

      var lowerCaseUrl = dcName.toLocaleLowerCase();
      if (lowerCaseUrl.includes("http") || lowerCaseUrl.includes("https")) throw "Invalid DC name";
      var persist = StreamConstants.PERSISTENT;
      var region = this.local ? "c8local" : "c8global";

      var tenant = this._connection.getTenantName();

      var dbName = this._connection.getFabricName();

      if (!dbName || !tenant) throw "Set correct DB and/or tenant name before using.";
      var noopProducerUrl = "wss://".concat(dcName, "/_ws/ws/v2/producer/").concat(persist, "/").concat(tenant, "/").concat(region, ".").concat(dbName, "/").concat(this.topic);
      this._noopProducer = webSocket_1.ws(noopProducerUrl);

      this._noopProducer.on("open", function () {
        _this2._setIntervalId = setInterval(function () {
          _this2._noopProducer.send(JSON.stringify({
            payload: "noop"
          }));
        }, 30000);
      });

      this._noopProducer.on("error", function (e) {
        return console.log("noop producer errored ", e);
      });
    }
  }, {
    key: "producer",
    value: function producer(message, dcName, callbackObj) {
      var _this3 = this;

      var onopen;
      var onclose;
      var onmessage;
      var onerror;

      if (callbackObj !== undefined) {
        onopen = callbackObj.onopen;
        onclose = callbackObj.onclose;
        onmessage = callbackObj.onmessage;
        onerror = callbackObj.onerror;
      }

      if (this._producer === undefined) {
        if (!dcName) throw "DC name not provided to establish producer connection";
        var lowerCaseUrl = dcName.toLocaleLowerCase();
        if (lowerCaseUrl.includes("http") || lowerCaseUrl.includes("https")) throw "Invalid DC name";
        var persist = StreamConstants.PERSISTENT;
        var region = this.local ? "c8local" : "c8global";

        var tenant = this._connection.getTenantName();

        var dbName = this._connection.getFabricName();

        if (!dbName || !tenant) throw "Set correct DB and/or tenant name before using.";
        var producerUrl = "wss://".concat(dcName, "/_ws/ws/v2/producer/").concat(persist, "/").concat(tenant, "/").concat(region, ".").concat(dbName, "/").concat(this.topic);
        this._producer = webSocket_1.ws(producerUrl);

        this._producer.on("message", function (msg) {
          typeof onmessage === "function" && onmessage(msg);
        });

        this._producer.on("open", function () {
          _this3._producerIntervalId = setInterval(function () {
            _this3._producer.send(JSON.stringify({
              payload: "noop"
            }));
          }, 30000);

          if (!Array.isArray(message)) {
            _this3._producer.send(JSON.stringify({
              payload: btoa_1.btoa(message)
            }));
          } else {
            for (var i = 0; i < message.length; i++) {
              _this3._producer.send(JSON.stringify({
                payload: btoa_1.btoa(message[i])
              }));
            }
          }

          typeof onopen === "function" && onopen();
        });

        this._producer.on("close", function () {
          clearInterval(_this3._producerIntervalId);
          typeof onclose === "function" && onclose();
        });

        this._producer.on("error", function (e) {
          typeof onerror === "function" && onerror(e);
        });
      } else {
        if (this._producer.readyState === this._producer.OPEN) {
          if (!Array.isArray(message)) {
            this._producer.send(JSON.stringify({
              payload: btoa_1.btoa(message)
            }));
          } else {
            for (var i = 0; i < message.length; i++) {
              this._producer.send(JSON.stringify({
                payload: btoa_1.btoa(message[i])
              }));
            }
          }
        } else {
          console.warn("Producer connection not open yet. Please wait.");
        }
      }
    }
  }, {
    key: "closeConnections",
    value: function closeConnections() {
      this._setIntervalId && clearInterval(this._setIntervalId);
      this._producerIntervalId && clearInterval(this._producerIntervalId);
      this._producer && this._producer.terminate();
      this._noopProducer && this._noopProducer.terminate();
      this._consumers && this._consumers.forEach(function (consumer) {
        return consumer.terminate();
      });
    }
  }]);

  return Stream;
}();

exports.Stream = Stream;